import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getOrders = (
  {
    currentPage,
    pageSize,
    isLive,
    params = {}
  }
    : {
      currentPage: number,
      pageSize: number,
      isLive: boolean,
      params: Record<string, string | number | boolean>
    }
) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params
  };

  return axiosPrivate.get(`/dashboard/api/v1/orders`, { params: queryParams });
};